export default abstract class BaseLogo extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });

    const wrapper = document.createElement('div');
    wrapper.setAttribute('class', 'icon');
    wrapper.innerHTML = this.renderSVG();

    const style = document.createElement('style');
    style.textContent = `
      .icon {
          display: inline-block;
          color: inherit;
          width: fit-content;
          height: fit-content;
      }

      svg {
          display: block;
          width: fit-content;
          height: fit-content;
      }
    `;

    this.shadowRoot?.append(style, wrapper);
  }

  static get observedAttributes() {
    return ['style'];
  }

  attributeChangedCallback(name: string, _oldValue: string, newValue: string) {
    if (name === 'style') {
      this.shadowRoot?.querySelector('.icon')?.setAttribute('style', newValue);
    }
  }

  abstract renderSVG(): string;
}
